module.exports = __webpack_public_path__ + "static/media/milk_buns.9bc14e7e.jpg";